export const site = {
  theme: 'fiu',
  profileName: 'Ruimin Sun',
  institution: 'Florida International University',
  institutionShortName: 'FIU',
  institutionUrl: 'https://www.fiu.edu/',
  school: 'Knight Foundation School of Computing and Information Sciences',
  schoolUrl: 'https://www.cis.fiu.edu/',
  labName: 'RiS3 Lab',
  labAcronym: 'RiS3',
  labExpansion: 'Research in Security',
};
